import { Component, Input } from '@angular/core'

import { APIService } from 'api/module'
import { BaseComponent } from 'common/helpers'
import { MediaFile, MediaRootDetail } from 'elements-sdk/src'

@Component({
  selector: 'media-header-block',
  templateUrl: './mediaHeaderBlock.component.pug',
  styleUrls: ['./mediaHeaderBlock.component.scss'],
})
export class MediaHeaderBlockComponent extends BaseComponent {
  @Input() file?: MediaFile
  @Input() root?: MediaRootDetail
  @Input() isSearch = false
  @Input() isFlat = false
  @Input() showSearch = false
  @Input() showConfigure = false
  isBookmarked = false
  bookmarks: MediaFile[] = []

  constructor (private api: APIService) {
    super()
  }

  async ngOnInit () {
    this.isBookmarked = this.file?.isBookmarked ?? false
    this.bookmarks = await this.api.mediaLibrary.getBookmarkedMediaFilesDirectories({})
    this.bookmarks = this.bookmarks.filter(x => x.id !== this.file?.id)
  }

  getSearchLink () {
    if (this.file) {
      return `/media/search/folder/${this.file.id}`
    } else if (this.root) {
      return `/media/search/${this.root.id}`
    }
    return ''
  }

  toggleBookmark () {
    if (!this.file) {
      return
    }
    if (this.file.isBookmarked) {
      this.api.mediaLibrary.unbookmarkMediaDirectory(this.file)
    } else {
      this.api.mediaLibrary.bookmarkMediaDirectory(this.file)
    }
    this.isBookmarked = !this.isBookmarked
  }
}
